module.exports = __webpack_public_path__ + "img/1_028.ef649471.jpg";